<template>
  <div class="el-dialog-multi-checkbox-group">
    <el-dialog
      :close="handleClose"
      :visible.sync="dialogVisible2"
      class="dialog-center"
      custom-class="el-dialog--customize el-dialog-multi-checkbox-group"
      show-divider
      show-shadow
      title="经营类目"
      width="1100px"
    >
      <!--  -->
      <el-row style="width: 100%; border: 1px solid #f1f1f1; border-bottom: 0">
        <el-col
          style="
            width: 170px;
            border-right: 1px solid #f1f1f1;
            padding-left: 9px;
            height: 36px;
            line-height: 36px;
          "
        >
          一级类目
        </el-col>
        <el-col
          style="
            width: 244px;
            border-right: 1px solid #f1f1f1;
            padding-left: 9px;
            height: 36px;
            line-height: 36px;
          "
        >
          二级类目
        </el-col>
        <el-col
          style="
            width: 378px;
            padding-left: 9px;
            height: 36px;
            line-height: 36px;
          "
        >
          三级类目
        </el-col>
      </el-row>

      <container style="height: 500px; border: 1px solid #eee; border: 0" v-loading="sideLoading">
        <div style="display: flex; width: 100%">
          <el-aside
            style="
              height: 500px;
              border-top: 1px solid #f1f1f1;
            "
            width="170px"
          >
            <el-menu style="border: 1px solid #f1f1f1; border-top: 0;">
              <div
                v-for="(item, idx) in mockData"
                :key="idx"
                :class="activeAll(item)"
                :title="item.categoryName"
                style="height: 30px; line-height: 30px; margin-left: 9px;display: flex"
              >
                <el-checkbox
                  :key="idx"
                  v-model="item.isSelected"
                  :indeterminate="item.isSelected && !item.isAll"
                  style="padding-left: 11px;margin-right: 0"
                  @change="handleCheckAllChangeFirst(item)"
                >
                </el-checkbox>
                <p
                  style="color: #4a4a4a;margin-left: 15px;cursor: pointer;width: 100%"
                  @click.prevent="lookChoice(item, idx)"
                >
                  {{ item.categoryName }}
                </p>
              </div>
            </el-menu>
          </el-aside>

          <!-- 二级目录和三级目录的部分 -->
          <main style="flex: 1; height: 500px; padding: 0;overflow: auto;">
            <div
              v-for="(item2, index2) in qryCategoryByCodeTwo"
              :key="index2"
              class="check-box-tmpl"
            >
              <!-- 二级目录复选框 -->
              <el-checkbox
                :key="item2.categoryCode"
                v-model="item2.isSelected"
                :indeterminate="item2.isSelected && !item2.isAll"
                :label="item2.categoryCode"
                :title="item2.categoryName"
                class="all"
                @change="handleCheckedAll(item2, index2)"
              >
                {{ item2.categoryName }}
              </el-checkbox>
              <!-- 线 -->
              <div class="partition"></div>
              <!-- 三级目录复选框 -->
              <el-checkbox-group
                v-model="item2.checkList"
                :checkList="item2.checkList"
                class="child-checkbox"
                @change="handleCheckedChange(item2, index2)"
              >
                <template v-for="item3 in item2.shopThirdCategoryBOS">
                  <el-checkbox
                    :key="item3.categoryCode"
                    :class="{
                      textHiddenCk: item2.shopThirdCategoryBOS.length > 1
                    }"
                    :label="item3.categoryCode"
                    :title="item3.categoryName"
                  >{{ item3.categoryName }}
                  </el-checkbox>
                </template>
              </el-checkbox-group>
            </div>
          </main>
        </div>
      </container>

      <span slot="footer">
        <el-button size="mini" type="default-mini" @click="cancel"
        >取消</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="determine"
        >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import {selectAllCategory} from "@/api/apply-shop-edit.js";
// import data from './data';
import {Container, Main} from "ccui";

export default {
  name: "DialogMultiCheckboxGroup",
  props: {
    dialogVisible: Boolean,
    defaultPitchOn: {
      type: Array,
      default: [],
    },
    shopId: String,
    changeId: String,
    agentId: {
      type: String,
      default:
        "9F6FD19CCFA4A74EEA3E4B95AF093CFD469803DF46A5F8CDBEEBC96B7FC7DD4D",
    },
    shopType: {
      type: [String,Number],
      default: 1,
    }
  },
  components: {
    Container,
    Main,
  },
  data() {
    return {
      qryCategoryByCodeTwo: [],
      dataRequestArrCode: [],
      mockData: [],
      localData: [],
      dialogVisible2: false,
      num: 1,
      flag: false,
      sideLoading:true
    };
  },
  watch: {
    dialogVisible(val) {
      this.dialogVisible2 = val;
      if (val) {
        // 显示的时候初始化数据
        this.pushData();
      }
    },
    defaultPitchOn(e) {
      console.log(this.defaultPitchOn, "默认数据");
    },
    dialogVisible2(val) {
      this.$emit("update:dialogVisible", val);
    },
  },

  mounted() {
    this.dialogVisible2 = this.dialogVisible;
    this.pushData(); // 初始化请求所有数据
  },
  methods: {
    disabled(item) {
      if (this.qryCategoryByCodeTwo.length > 0) {
        if (
          this.qryCategoryByCodeTwo[0].parentCode === item.categoryCode &&
          this.qryCategoryByCodeTwo[0].parentCode
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
    activeAll(item) {
      if (this.qryCategoryByCodeTwo.length > 0) {
        if (
          this.qryCategoryByCodeTwo[0].parentCode === item.categoryCode &&
          this.qryCategoryByCodeTwo[0].parentCode
        ) {
          return "activeAll";
        } else {
          return "";
        }
      }
    },
    lookChoice(item, inx) {
      // 切换一级类目，直接替换二三级类目数组
      if (item.isSelected) {
        // 有选中，改变选中和全选状态，循环改变二级选中和全选选中数组，三级全部选中
        // 处理完上一步直接替换二三级类目数组
        item.shopSecondCategoryBOS.map((e) => {
          let list = [];
          e.shopThirdCategoryBOS.map((t) => {
            if (t.isSelected) {
              list.push(t.categoryCode);
            }
          });
          e.checkList = list;
        });
      } else {
        item.shopSecondCategoryBOS.map((e) => {
          e.checkList = [];
          e.shopThirdCategoryBOS.map((t) => {
            t.isSelected = false;
          });
        });
      }
      let arr = JSON.parse(JSON.stringify(item.shopSecondCategoryBOS));
      this.qryCategoryByCodeTwo = arr;
    },

    // 一级类目选哲
    handleCheckAllChangeFirst(item, flag = false) {
      console.log('handleCheckAllChangeFirst',item)
      if (item.isSelected) {
        // 全选，直接改变选中和全选状态，循环改变二级选中和全选选中数组，三级全部选中
        // 处理完上一步直接替换二三级类目数组
        item.isSelected = true;
        item.isAll = true;
        item.shopSecondCategoryBOS.map((e) => {
          e.isAll = true;
          e.isSelected = true;
          let list = [];
          e.shopThirdCategoryBOS.map((t) => {
            t.isSelected = true;
            list.push(t.categoryCode);
          });
          e.checkList = list;
        });
        flag && this.determine()
      } else {
        item.isSelected = false;
        item.isAll = false;
        item.shopSecondCategoryBOS.map((e) => {
          e.isAll = false;
          e.isSelected = false;
          e.checkList = [];
          e.shopThirdCategoryBOS.map((t) => {
            t.isSelected = false;
          });
        });
      }
      let arr = JSON.parse(JSON.stringify(item.shopSecondCategoryBOS));
      this.qryCategoryByCodeTwo = [...arr];
    },
    handleClose() {
      this.$emit("update:dialogVisible", false);
    },
    handleCheckedAll(data, childrenOneIdx) {
      if (data.isSelected) {
        // 全部选中，循环三级类目，全部设为选中,三级类目选中数组变更为全部
        // 在循环总数据，判断一级类目是否需要全选
        data.isSelected = true;
        data.isAll = true;
        let list = [];
        data.shopThirdCategoryBOS.map((e) => {
          e.isSelected = true;
          list.push(e.categoryCode);
        });
        data.checkList = list;
        let arr2 = JSON.parse(JSON.stringify(this.mockData));
        arr2.map((i) => {
          if (
            data.parentCode === i.categoryCode ||
            data.parentCode.slice(0, 2) === i.categoryCode
          ) {
            let num = 0;
            i.shopSecondCategoryBOS[childrenOneIdx] = data;
            i.shopSecondCategoryBOS.map((it) => {
              if (it.isAll) {
                num++;
              }
            });
            if (num === i.shopSecondCategoryBOS.length) {
              // 全选
              i.isAll = true;
              i.isSelected = true;
            } else if (num === 0) {
              // 全部未选中
              i.isAll = false;
              i.isSelected = false;
            } else {
              // 部分选中
              i.isAll = false;
              i.isSelected = true;
            }
          }
        });
        let arr = JSON.parse(JSON.stringify(this.qryCategoryByCodeTwo));
        arr[childrenOneIdx] = data;
        this.qryCategoryByCodeTwo = [...arr];
        this.mockData = [...arr2]
      } else {
        data.isSelected = false;
        data.isAll = false;
        data.checkList = [];
        data.shopThirdCategoryBOS.map((e) => {
          e.isSelected = false;
        });
        let arr2 = JSON.parse(JSON.stringify(this.mockData));
        arr2.map((i) => {
          if (
            data.parentCode === i.categoryCode ||
            data.parentCode.slice(0, 2) === i.categoryCode
          ) {
            let num = 0;
            i.shopSecondCategoryBOS[childrenOneIdx] = data;
            i.shopSecondCategoryBOS.map((it) => {
              if (it.isAll) {
                num++;
              }
            });
            if (num === i.shopSecondCategoryBOS.length) {
              // 全选
              i.isAll = true;
              i.isSelected = true;
            } else if (num === 0) {
              // 全部未选中
              i.isAll = false;
              i.isSelected = false;
            } else {
              // 部分选中
              i.isAll = false;
              i.isSelected = true;
            }
          }
        });
        let arr = JSON.parse(JSON.stringify(this.qryCategoryByCodeTwo));
        arr[childrenOneIdx] = data;
        this.qryCategoryByCodeTwo = [...arr];
        this.mockData = [...arr2]
      }
    },

    // 三级类目选折
    handleCheckedChange(item, index) {
      console.log(item, "item....");
      console.log(item.checkList, "item.checkList//...");
      item.shopThirdCategoryBOS.map((e) => {
        if (item.checkList.indexOf(e.categoryCode) != -1) {
          e.isSelected = true;
        } else {
          e.isSelected = false;
        }
      });
      if (item.checkList.length === item.shopThirdCategoryBOS.length) {
        item.isSelected = true;
        item.isAll = true;
      } else if (item.checkList.length === 0) {
        item.isSelected = false;
        item.isAll = false;
      } else {
        item.isSelected = true;
        item.isAll = false;
      }
      // let arr2 = JSON.parse(JSON.stringify(this.mockData));
      // arr2.map((i) => {
      this.mockData.map((i) => {
        if (
          item.parentCode === i.categoryCode ||
          item.parentCode.slice(0, 2) === i.categoryCode
        ) {
          // 找到总数据和点击的数据对应的二级目录
          // 替换一下数据，然后循环一级目录下所有二级目录
          // 如果全选中项和总数相等，一级全选否则相反
          let num = 0;
          // num2用来记录是否有选中的二级
          let num2 = 0;
          i.shopSecondCategoryBOS[index] = item;
          i.shopSecondCategoryBOS.map((it) => {
            if (it.isSelected && it.isAll) {
              num++;
            } else {
              if (it.isSelected) {
                num2++
              }
            }
          });
          if (num === i.shopSecondCategoryBOS.length) {
            // 全选
            i.isAll = true;
            i.isSelected = true;
          } else if (num === 0) {
            // 二级没有全选中的，判断下有没有选中的
            if (num2 === 0) {
              // 一个选中的都没有
              i.isAll = false;
              i.isSelected = false;
            } else {
              i.isAll = false;
              i.isSelected = true;
            }
          } else {
            // 部分选中
            i.isAll = false;
            i.isSelected = true;
          }
        }
      });
      // this.mockData = arr2;
      let arr = JSON.parse(JSON.stringify(this.qryCategoryByCodeTwo));
      arr[index] = item;
      this.qryCategoryByCodeTwo = [...arr];
    },
    cancel() {
      this.dialogVisible2 = false;
      this.$emit("update:dialogVisible", false);
    },
    determine() {
      this.dialogVisible2 = false;
      this.$emit("update:dialogVisible", false);
      this.$emit("determine", this.mockData);
    },

    // 初始化处理否全选和选中状态数据
    isAllList(arr1) {
      let arr = JSON.parse(JSON.stringify(arr1));
      arr.map((item1) => {
        if (item1.isSelected === true || item1.isSelected === "1") {
          // 选中
          item1.isSelected = true;
        } else {
          item1.isSelected = false;
          item1.isAll = false;
        }
        if (item1.shopSecondCategoryBOS.length > 0) {
          // 有二级类目，循环
          let num2 = 0;
          item1.shopSecondCategoryBOS.map((item2) => {
            if (item2.isSelected === true || item2.isSelected === "1") {
              // 选中
              item2.isSelected = true;
            } else {
              item2.isSelected = false;
              item2.isAll = false;
            }
            if (item2.shopThirdCategoryBOS.length > 0) {
              // 有三级类目，循环
              let num3 = 0;
              item2.shopThirdCategoryBOS.map((item3) => {
                if (item3.isSelected === true || item3.isSelected === "1") {
                  // 当前项选中
                  num3++;
                  item3.isSelected = true;
                } else {
                  item3.isSelected = false;
                }
              });
              if (num3 === item2.shopThirdCategoryBOS.length) {
                item2.isAll = true;
                item2.isSelected = true;
                num2++;
              } else if (num3 === 0) {
                // 全部未选中
                item2.isAll = false;
                item2.isSelected = false;
              } else {
                // 部分选中
                item2.isAll = false;
                item2.isSelected = true;
              }
            }
          });
          if (num2 === item1.shopSecondCategoryBOS.length) {
            item1.isAll = true;
          } else if (num2 === 0) {
            // 全部未选中
            item1.isAll = false;
          } else {
            // 部分选中
            item1.isAll = false;
          }
        }
      });
      return arr;
    },

    pushData(flag) {
      console.log('pushData!!!!!!!!!',flag)
      if (this.defaultPitchOn.length > 0) {
        // 有默认缓存数据，不需要请求数据
        let arr = JSON.parse(JSON.stringify(this.defaultPitchOn))
        this.mockData = [...arr];
        this.selectAllCategory(this.mockData[0], 0);
      } else {
        this.flag = true;
        let formData = {
          agentId: this.agentId,
          shopId: this.shopId,
        };
        console.log(this.changeId, 'this.changeIdthis.changeIdthis.changeIdthis.changeId')
        if (this.changeId) {
          formData.changeId = this.changeId;
        }
        this.sideLoading = true
        selectAllCategory(formData)
          .then((res) => {
            if (res.data.code === "0") {

              if (this.shopType == 6){
                // 新增的东西-1
                let arrSeven = []
                res.data.data.filter(v => {
                  if (this.shopType == 6) {
                    if (Number(v.categoryCode) >= 81 && Number(v.categoryCode) <= 93){
                      arrSeven.push(v)
                    }
                  } else {
                    if (Number(v.categoryCode) < 81 || Number(v.categoryCode) > 93){
                      arrSeven.push(v)
                    }
                  }
                });
                res.data.data = arrSeven

              }else if (this.shopType == 7){
                // 新增的东西-1
                let arrSeven = []
               res.data.data.filter(v => {
                  if (this.shopType == 7) {
                    if (v.categoryCode==61||v.categoryCode==62||v.categoryCode==63){
                      arrSeven.push(v)
                    }
                  } else {
                    if (v.categoryCode!=61||v.categoryCode!=62||v.categoryCode!=63){
                      arrSeven.push(v)
                    }
                  }
                });
                res.data.data = arrSeven
              }


              let mockarr = this.isAllList(res.data.data);
              // this.defaultPitchOn.map((item) => {
              //   mockarr.map((e) => {
              //     if (item.categoryCodes.split(",")[0] === e.categoryCode) {
              //       e.shopThirdCategoryBOS.push(item);
              //     }
              //   });
              // });
              mockarr.map((item) => {
                item.shopSecondCategoryBOS.map((e) => {
                  if (e.categoryCodes) {
                    e.categoryCode = e.categoryCodes.split(",")[1];
                    e.categoryName = e.categoryNames.split(">")[1];
                    e.shopThirdCategoryBOS = [];
                    setTimeout(() => {
                      e.categoryCodes
                        .split(",")[2]
                        .split("\\")
                        .map((r, ir) => {
                          let data = {};
                          data.categoryCode = r;
                          data.isSelected = true;
                          e.categoryNames
                            .split(">")[2]
                            .split("\\")
                            .map((t, it) => {
                              if (ir === it) {
                                data.categoryName = t;
                                e.shopThirdCategoryBOS.push(data);
                                e.shopThirdCategoryBOS = this.unique(
                                  e.shopThirdCategoryBOS
                                );
                              }
                            });
                        });
                    }, 10);
                  }
                });
              });
              this.sideLoading = false
              // flag && (mockarr[0].isSelected = true)
              flag && (mockarr.map(item=>{
                item.isSelected = true
              }))
              this.mockData = mockarr;
              // this.$set(this.mockData[0],'isSelected',true)
              flag && mockarr.map(item=>{
                this.handleCheckAllChangeFirst(item, flag)
              })
              this.$emit('refdata', mockarr)
              mockarr.map(item=>{
                this.selectAllCategory(item, 0);
              })
            } else {
            }
            this.flag = false;
          })
          .catch(() => {
            this.flag = false;
          });
      }
    },

    // 获取二三级类目
    selectAllCategory(itemFirst, idx) {
      let arr = JSON.parse(JSON.stringify(itemFirst.shopSecondCategoryBOS));
      if (itemFirst.isSelected) {// 有选中的下级
        arr.map((e) => {
          if (e.isSelected) { // 有选中的下级
            let checkList = [];
            e.shopThirdCategoryBOS.map((item1) => {
              if (item1.isSelected) {
                checkList.push(item1.categoryCode);
              }
            });
            e.checkList = checkList;
          } else {
            e.checkList = [];
          }
        });
      } else {
        arr.map((e) => {
          e.checkList = [];
          e.isSelected = false;
          e.isAll = false;
          e.shopThirdCategoryBOS.map((item1) => {
            item1.isSelected = false;
          });
        });
      }
      this.qryCategoryByCodeTwo = [...arr]
    },

    unique(arr, code) {
      // 根据唯一标识orderId来对数组进行过滤
      const res = new Map(); // 定义常量 res,值为一个Map对象实例
      // 返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
      return arr.filter(
        (arr) => !res.has(arr.categoryCode) && res.set(arr.categoryCode, 1)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog-multi-checkbox-group /deep/ .el-dialog__body {
  min-height: 557px !important;
  max-height: 557px !important;
  height: 557px !important;
  overflow: hidden !important;
}

.el-dialog-multi-checkbox-group .el-aside .el-checkbox__label {
  line-height: 1;
  cursor: pointer !important;
}

.el-dialog-multi-checkbox-group .el-aside .el-checkbox__input {
  line-height: 1;
  height: 57%;
}

.el-dialog-multi-checkbox-group .el-aside .activeAll {
  background-color: #ffe8ea;
}

.el-dialog-multi-checkbox-group .el-aside .activeAll .el-checkbox__label p {
  color: #ff142f !important;
}

.el-dialog-multi-checkbox-group .check-box-tmpl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: auto;
}

.el-dialog-multi-checkbox-group .check-box-tmpl .el-checkbox__label {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  white-space: normal;
}

.el-dialog-multi-checkbox-group .check-box-tmpl .all {
  width: 203px;
}

.el-dialog-multi-checkbox-group .check-box-tmpl .el-checkbox-group {
  -webkit-box-flex: 3;
  -ms-flex: 3;
  flex: 3;
}
</style>
